import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { InteractionStatus } from '../../../../../types/InteractionStatus';
import FormSubmitOrCancel from '../../../../molecules/Form/components/FormSubmitOrCancel/FormSubmitOrCancel';
import LiveRegion from '../../../../atoms/LiveRegion/LiveRegion';
import { FormUtils, useFormContext } from '../../../../molecules/Form';
import { CloseSecondaryView } from '../../BlockInteractionsTypes';

type DeleteBlockFormTemplateType = {
  cancelAction: CloseSecondaryView;
  headline: string;
  headlineId: string;
  transnamespaceAndKey: string;
};

export function DeleteBlockFormTemplate({
  cancelAction,
  headline,
  headlineId,
  transnamespaceAndKey,
}: DeleteBlockFormTemplateType) {
  const { status, getStatus } = useFormContext();
  const { t } = useTranslation();

  const statusMessages = useMemo(() => {
    return {
      [InteractionStatus.SUCCESS]: FormUtils.createStatusMessage(t(`${transnamespaceAndKey}.status.success`)),
      [InteractionStatus.SENDING]: FormUtils.createStatusMessage(t(`${transnamespaceAndKey}.status.sending`)),
      [InteractionStatus.FAIL]: FormUtils.createStatusMessage(t(`${transnamespaceAndKey}.status.fail`)),
    };
  }, [t, transnamespaceAndKey]);

  return (
    <>
      <FormSubmitOrCancel
        headline={headline}
        headlineId={headlineId}
        disableCancelButton={[InteractionStatus.SENDING, InteractionStatus.SUCCESS].includes(
          status as InteractionStatus
        )}
        hierarchy={3}
        disableSubmitButton={[InteractionStatus.SENDING, InteractionStatus.SUCCESS].includes(
          status as InteractionStatus
        )}
        cancelAction={cancelAction}
        hideSubmitButton={false}
      />
      <LiveRegion htmlTag="div" invisible={false}>
        {getStatus(statusMessages)}
      </LiveRegion>
    </>
  );
}
